import { organizationActions } from "./organization-slice";
import { uiActions } from "../ui-slice";

export const GetOrganizations = (email, showNotification) => {
  return async (dispatch) => {
   if (showNotification !== undefined && showNotification === true) {
      dispatch(
        uiActions.showNotification({
          status: "pending",
          title: "Cargando información",
          message: "Se esta solicitando la información al servidor.",
        })
      );
    }
    const GetOrganizationsInfo = async () => {
      const response = await fetch(
        `${process.env.REACT_APP_URL}digitalsign/user/organization/getall`,
        {
          method: "POST",
          body: JSON.stringify({
            UserName: email,
          }),
          headers: {
            "Content-Type": "application/json",
            APIKey: process.env.REACT_APP_KEY,
            APISecretKey: process.env.REACT_APP_SECRET_KEY,
            APPName: process.env.REACT_APP_NAME,
          },
        }
      );
      if (!response.ok) {
        throw new Error("No se pudo obtener la información solicitada");
      }
      const data = await response.json();
      return data;
    };

    try {
      const response = await GetOrganizationsInfo();
      if (response.result.errorCode === "OK") {
        dispatch(
          organizationActions.setOrganizations({
            organizations: response.data
          })
        );
       if (showNotification !== undefined && showNotification === true) {
          dispatch(
            uiActions.showNotification({
              status: "success",
              title: "Datos Cargados",
              message: response.result.message,
            })
          );
        }
      }
      if (response.result.errorCode === "Warning") {
        dispatch(
          organizationActions.setOrganizations({
            statues: [],
          })
        );
       if (showNotification !== undefined && showNotification === true) {
          dispatch(
            uiActions.showNotification({
              status: "warning",
              title: "Advertencia",
              message: response.result.message,
            })
          );
        }
      }
    } catch (error) {
      dispatch(
        uiActions.showNotification({
          status: "error",
          title: "Error!",
          message: "No se pudo obtener la información solicitada",
        })
      );
    }
  };
};
export const GetOrganization = (id, email) => {
  return async (dispatch) => {
    dispatch(
      uiActions.showNotification({
        status: "pending",
        title: "Solicitando organización",
        message: "Solicitando organización al servidor.",
      })
    );
    const getOrganizationInfo = async () => {
      const response = await fetch(
        `${process.env.REACT_APP_URL}digitalsign/user/organization/getById`,
        {
          method: "POST",
          body: JSON.stringify({
            UserName: email,
            id: id,
          }),
          headers: {
            "Content-Type": "application/json",
            APIKey: process.env.REACT_APP_KEY,
            APISecretKey: process.env.REACT_APP_SECRET_KEY,
            APPName: process.env.REACT_APP_NAME,
          },
        }
      );
      if (!response.ok) {
        throw new Error("No se pudo obtener el organización");
      }
      const data = await response.json();
      return data;
    };
    try {
      const response = await getOrganizationInfo();
      if (response.result.errorCode === "OK") {
        dispatch(
          organizationActions.setOrganization({
            organization: response.data,
          })
        );
        dispatch(
          uiActions.showNotification({
            status: "success",
            title: "Datos Cargados",
            message: response.result.message,
          })
        );
      }
      if (response.result.errorCode === "Warning") {
        dispatch(
          organizationActions.setOrganization({
            organization: {},
          })
        );
        dispatch(
          uiActions.showNotification({
            status: "warning",
            title: "Advertencia",
            message: response.result.message,
          })
        );
      }
    } catch (error) {
      dispatch(
        uiActions.showNotification({
          status: "error",
          title: "Error!",
          message: "No se pudo obtener el organización",
        })
      );
    }
  };
};
export const UpdateOrganization = (organization, email) => {
  return async (dispatch) => {
    dispatch(
      uiActions.showNotification({
        status: "pending",
        title: "Actualizando organización",
        message: "Solicitando Actualización del organización al servidor.",
      })
    );
    const updateOrganizationInfo = async () => {
      const response = await fetch(
        `${process.env.REACT_APP_URL}digitalsign/user/organization/update`,
        {
          method: "POST",
          body: JSON.stringify({
            ...organization,
            UserName: email,
           
            // Id: organization.id,
            // Name: organization.name,
            // City: organization.city,
            // CountryId: organization.countryId,
            // Address: organization.address,
            // Email: organization.email,
            // Ra: organization.ra,
            // ZipCode: organization.zipCode,
            // Identifier: organization.identifier,
          }),
          headers: {
            "Content-Type": "application/json",
            APIKey: process.env.REACT_APP_KEY,
            APISecretKey: process.env.REACT_APP_SECRET_KEY,
            APPName: process.env.REACT_APP_NAME,
          },
        }
      );
      if (!response.ok) {
        throw new Error("No se pudo actualizar el organización");
      }
      const data = await response.json();
      return data;
    };
    try {
      const response = await updateOrganizationInfo();
      if (response.result.errorCode === "OK") {
        dispatch(
          organizationActions.setOrganization({
            organization: response.data,
          })
        );
        dispatch(
          uiActions.showNotification({
            status: "success",
            title: "Organización Actualizado",
            message: response.result.message,
          })
        );
      }
      if (response.result.errorCode === "Warning") {
        dispatch(
          organizationActions.setOrganization({
            organization: {},
          })
        );
        dispatch(
          uiActions.showNotification({
            status: "warning",
            title: "Advertencia",
            message: response.result.message,
          })
        );
      }
    } catch (error) {
      dispatch(
        uiActions.showNotification({
          status: "error",
          title: "Error!",
          message: "No se pudo actualizar el organización",
        })
      );
    }
  };
};
export const CreateOrganization = (organization, email) => {
  return async (dispatch) => {
    dispatch(
      uiActions.showNotification({
        status: "pending",
        title: "Creando organización",
        message: "Solicitando Creación del organización al servidor.",
      })
    );
    const createOrganizationInfo = async () => {
      const response = await fetch(
        `${process.env.REACT_APP_URL}digitalsign/user/organization/create`,
        {
          method: "POST",
          body: JSON.stringify({
            UserName: email,
            Name: organization.name,
            City: organization.city,
            Countryid: organization.countryid,
            Address: organization.address,
            Email: organization.email,
            Ra: organization.ra,
            ZipCode: organization.zipCode,
            Identifier: organization.identifier,
          }),
          headers: {
            "Content-Type": "application/json",
            APIKey: process.env.REACT_APP_KEY,
            APISecretKey: process.env.REACT_APP_SECRET_KEY,
            APPName: process.env.REACT_APP_NAME,
          },
        }
      );
      if (!response.ok) {
        throw new Error("No se pudo crear el organización");
      }
      const data = await response.json();
      return data;
    };
    try {
      const response = await createOrganizationInfo();
      if (response.result.errorCode === "OK") {
        dispatch(
          organizationActions.setOrganization({
            organization: response.data,
          })
        );
        dispatch(
          uiActions.showNotification({
            status: "success",
            title: "Organización Creado",
            message: response.result.message,
          })
        );
      }
      if (response.result.errorCode === "Warning") {
        dispatch(
          organizationActions.setOrganization({
            organization: {},
          })
        );
        dispatch(
          uiActions.showNotification({
            status: "warning",
            title: "Advertencia",
            message: response.result.message,
          })
        );
      }
    } catch (error) {
      dispatch(
        uiActions.showNotification({
          status: "error",
          title: "Error!",
          message: "No se pudo crear el organización",
        })
      );
    }
  };
};
export const ActiveOrganization = (id, email) => {
  return async (dispatch) => {
    dispatch(
      uiActions.showNotification({
        status: "pending",
        title: "Activando organización",
        message: "Solicitando activación del organización al servidor.",
      })
    );
    const activeOrganizationInfo = async () => {
      const response = await fetch(
        `${process.env.REACT_APP_URL}digitalsign/user/organization/active`,
        {
          method: "POST",
          body: JSON.stringify({
            UserName: email,
            id: id,
          }),
          headers: {
            "Content-Type": "application/json",
            APIKey: process.env.REACT_APP_KEY,
            APISecretKey: process.env.REACT_APP_SECRET_KEY,
            APPName: process.env.REACT_APP_NAME,
          },
        }
      );
      if (!response.ok) {
        throw new Error("No se pudo activar el organización");
      }
      const data = await response.json();
      return data;
    };
    try {
      const response = await activeOrganizationInfo();
      if (response.result.errorCode === "OK") {
        dispatch(
          organizationActions.setOrganization({
            organization: response.data,
          })
        );
        dispatch(
          uiActions.showNotification({
            status: "success",
            title: "Organización Activada",
            message: response.result.message,
          })
        );
      }
      if (response.result.errorCode === "Warning") {
        dispatch(
          organizationActions.setOrganization({
            organization: {},
          })
        );
        dispatch(
          uiActions.showNotification({
            status: "warning",
            title: "Advertencia",
            message: response.result.message,
          })
        );
      }
    } catch (error) {
      dispatch(
        uiActions.showNotification({
          status: "error",
          title: "Error!",
          message: "No se pudo activar la organización",
        })
      );
    }
  };
};
export const InactiveOrganization = (id, email) => {
  return async (dispatch) => {
    dispatch(
      uiActions.showNotification({
        status: "pending",
        title: "Inactivando organización",
        message: "Solicitando activación de la organización al servidor.",
      })
    );
    const inactiveOrganizationInfo = async () => {
      const response = await fetch(
        `${process.env.REACT_APP_URL}digitalsign/user/organization/inactive`,
        {
          method: "POST",
          body: JSON.stringify({
            UserName: email,
            Id: id,
          }),
          headers: {
            "Content-Type": "application/json",
            APIKey: process.env.REACT_APP_KEY,
            APISecretKey: process.env.REACT_APP_SECRET_KEY,
            APPName: process.env.REACT_APP_NAME,
          },
        }
      );
      if (!response.ok) {
        throw new Error("No se pudo inactivar el organización");
      }
      const data = await response.json();
      return data;
    };
    try {
      const response = await inactiveOrganizationInfo();
      if (response.result.errorCode === "OK") {
        dispatch(
          organizationActions.setOrganization({
            organization: response.data,
          })
        );
        dispatch(
          uiActions.showNotification({
            status: "success",
            title: "Organización Inactivado",
            message: response.result.message,
          })
        );
      }
      if (response.result.errorCode === "Warning") {
        dispatch(
          organizationActions.setOrganization({
            organization: {},
          })
        );
        dispatch(
          uiActions.showNotification({
            status: "warning",
            title: "Advertencia",
            message: response.result.message,
          })
        );
      }
    } catch (error) {
      dispatch(
        uiActions.showNotification({
          status: "error",
          title: "Error!",
          message: "No se pudo inactivar el organización",
        })
      );
    }
  };
};
